import axios from 'axios';
import { cnxAPI, notifica } from './utils';
import api from '../service/api';

var a = null, b = null, c = null;
//Función que trae los combos para los filtros
function getEstados(_callback) {
	api.get('catalogos/estados', {}).then(function (response) {
		if (response.status !== 200) {
			notifica('warning', response.data.message, 'Error en la consulta de estados!');
			a = [];
		} else {
			a = Array.isArray(response.data) ? response.data : [];
		}
	}).catch(function (error) {
		notifica('danger', error, 'Error');
		a = [];
	}).then(() => _callback(a));
}

//Función para obtener los municipios
function getMunicipios(_callback) {
	api.get('municipio', {})
	.then(function (response) {
		if (response.status !== 200) {
			notifica('warning', response.data.message, 'Error en la consulta de estados!');
			c = [];
		} else {
			c = Array.isArray(response.data) ? response.data : [];
		}
	}).catch(function (error) {
		notifica('danger', error, 'Error');
		c = [];
	}).then(() => _callback(c));
}

function getCombos(_callback) {
	api.get('candidatos/combos?idCandidato=1', {})
	.then(function (response) {
		if (response.status !== 200) {
			notifica('warning', response.data.message, 'Error en la consulta de estados!');
			b = [];
		} else {
			b = Array.isArray(response.data) ? response.data : [];
		}
	}).catch(function (error) {
		notifica('danger', error, 'Error');
		b = [];
	}).then(() => _callback(b));
}

var dat_categ = [
	{
		idCategoria: 1,
		categoria: 'Administración'
	},
	{
		idCategoria: 2,
		categoria: 'Contabilidad'
	},
	{
		idCategoria: 3,
		categoria: 'Tecnologías de la información'
	},
	{
		idCategoria: 4,
		categoria: 'Operaciones'
	}
];

var dat_dFechas = [
	{
		valor: 0,
		texto: 'Hoy'
	},
	{
		valor: 1,
		texto: 'Ayer'
	},
	{
		valor: 7,
		texto: 'Esta Semana'
	},
	{
		valor: 15,
		texto: '15 días'
	},
	{
		valor: 30,
		texto: 'Un Mes'
	}];

var dat_salario = [
	{
		desde: 0,
		hasta: 10000,
		texto: '0 a 10,000'
	},
	{
		desde: 10001,
		hasta: 15000,
		texto: '10,001 a 15,000'
	},
	{
		desde: 15001,
		hasta: 20000,
		texto: '15,001 a 20,000'
	},
	{
		desde: 20001,
		hasta: 30000,
		texto: '20,001 a 30,000'
	},
	{
		desde: 30001,
		hasta: 100000,
		texto: 'más de 30,000'
	}
];

var dat_contrato = [
	{
		idContrato: 1,
		tipoContrato: 'Temporal'
	},
	{
		idContrato: 2,
		tipoContrato: 'Permanente'
	},
	{
		idContrato: 3,
		tipoContrato: 'Mixto'
	}
];

var dat_jornada = [
	{
		idJornada: 1,
		tipoJornada: 'Completa'
	},
	{
		idJornada: 2,
		tipoJornada: 'Medio Tiempo'
	},
	{
		idJornada: 3,
		tipoJornada: '12 Hrs'
	}
];

var dat_categoria = [
	{
		idCategoria: 1,
		categoria: 'Administración'
	},
	{
		idCategoria: 2,
		categoria: 'Contabilidad'
	},
	{
		idCategoria: 3,
		categoria: 'Derecho'
	},
	{
		idCategoria: 4,
		categoria: 'Farmaceutico'
	},
	{
		idCategoria: 5,
		categoria: 'Operaciones'
	},
	{
		idCategoria: 6,
		categoria: 'Tecnologías de la Información'
	}
];

var dat_ciudad = [
	{
		idCiudad: 1,
		ciudad: 'Azcapotzalco'
	},
	{
		idCiudad: 2,
		ciudad: 'Coyoacán'
	},
	{
		idCiudad: 3,
		ciudad: 'Iztacalco'
	},
	{
		idCiudad: 4,
		ciudad: 'Iztapalapa'
	},
	{
		idCiudad: 5,
		ciudad: 'Tláhuac'
	},
	{
		idCiudad: 6,
		ciudad: 'Tlalpan'
	},
	{
		idCiudad: 7,
		ciudad: 'Cuauhtémoc'
	},
	{
		idCiudad: 8,
		ciudad: 'Miguel Hidalgo'
	}
];

var dat_ciudades = [
	{
		abbr: "AL",
		nombre: "Alabama",
		capital: "Montgomery"
	},
	{
		abbr: "AK",
		nombre: "Alaska",
		capital: "Juneau"
	},
	{
		abbr: "AZ",
		nombre: "Arizona",
		capital: "Phoenix"
	},
	{
		abbr: "AR",
		nombre: "Arkansas",
		capital: "Little Rock"
	},
	{
		abbr: "CA",
		nombre: "California",
		capital: "Sacramento"
	},
	{
		abbr: "CO",
		nombre: "Colorado",
		capital: "Denver"
	},
	{
		abbr: "CT",
		nombre: "Connecticut",
		capital: "Hartford"
	},
	{
		abbr: "DE",
		nombre: "Delaware",
		capital: "Dover"
	},
	{
		abbr: "FL",
		nombre: "Florida",
		capital: "Tallahassee"
	},
	{
		abbr: "GA",
		nombre: "Georgia",
		capital: "Atlanta"
	},
	{
		abbr: "HI",
		nombre: "Hawaii",
		capital: "Honolulu"
	},
	{
		abbr: "ID",
		nombre: "Idaho",
		capital: "Boise"
	},
	{
		abbr: "IL",
		nombre: "Illinois",
		capital: "Springfield"
	},
	{
		abbr: "IN",
		nombre: "Indiana",
		capital: "Indianapolis"
	},
	{
		abbr: "IA",
		nombre: "Iowa",
		capital: "Des Moines"
	},
	{
		abbr: "KS",
		nombre: "Kansas",
		capital: "Topeka"
	},
	{
		abbr: "KY",
		nombre: "Kentucky",
		capital: "Frankfort"
	},
	{
		abbr: "LA",
		nombre: "Louisiana",
		capital: "Baton Rouge"
	},
	{
		abbr: "ME",
		nombre: "Maine",
		capital: "Augusta"
	},
	{
		abbr: "MD",
		nombre: "Maryland",
		capital: "Annapolis"
	},
	{
		abbr: "MA",
		nombre: "Massachusetts",
		capital: "Boston"
	},
	{
		abbr: "MI",
		nombre: "Michigan",
		capital: "Lansing"
	},
	{
		abbr: "MN",
		nombre: "Minnesota",
		capital: "Saint Paul"
	},
	{
		abbr: "MS",
		nombre: "Mississippi",
		capital: "Jackson"
	},
	{
		abbr: "MO",
		nombre: "Missouri",
		capital: "Jefferson City"
	},
	{
		abbr: "MT",
		nombre: "Montana",
		capital: "Helana"
	},
	{
		abbr: "NE",
		nombre: "Nebraska",
		capital: "Lincoln"
	},
	{
		abbr: "NV",
		nombre: "Nevada",
		capital: "Carson City"
	},
	{
		abbr: "NH",
		nombre: "New Hampshire",
		capital: "Concord"
	},
	{
		abbr: "NJ",
		nombre: "New Jersey",
		capital: "Trenton"
	},
	{
		abbr: "NM",
		nombre: "New Mexico",
		capital: "Santa Fe"
	},
	{
		abbr: "NY",
		nombre: "New York",
		capital: "Albany"
	},
	{
		abbr: "NC",
		nombre: "North Carolina",
		capital: "Raleigh"
	},
	{
		abbr: "ND",
		nombre: "North Dakota",
		capital: "Bismarck"
	},
	{
		abbr: "OH",
		nombre: "Ohio",
		capital: "Columbus"
	},
	{
		abbr: "OK",
		nombre: "Oklahoma",
		capital: "Oklahoma City"
	},
	{
		abbr: "OR",
		nombre: "Oregon",
		capital: "Salem"
	},
	{
		abbr: "PA",
		nombre: "Pennsylvania",
		capital: "Harrisburg"
	},
	{
		abbr: "RI",
		nombre: "Rhode Island",
		capital: "Providence"
	},
	{
		abbr: "SC",
		nombre: "South Carolina",
		capital: "Columbia"
	},
	{
		abbr: "SD",
		nombre: "South Dakota",
		capital: "Pierre"
	},
	{
		abbr: "TN",
		nombre: "Tennessee",
		capital: "Nashville"
	},
	{
		abbr: "TX",
		nombre: "Texas",
		capital: "Austin"
	},
	{
		abbr: "UT",
		nombre: "Utah",
		capital: "Salt Lake City"
	},
	{
		abbr: "VT",
		nombre: "Vermont",
		capital: "Montpelier"
	},
	{
		abbr: "VA",
		nombre: "Virginia",
		capital: "Richmond"
	},
	{
		abbr: "WA",
		nombre: "Washington",
		capital: "Olympia"
	},
	{
		abbr: "WV",
		nombre: "West Virginia",
		capital: "Charleston"
	},
	{
		abbr: "WI",
		nombre: "Wisconsin",
		capital: "Madison"
	},
	{
		abbr: "WY",
		nombre: "Wyoming",
		capital: "Cheyenne"
	}
];

export { getEstados, getCombos, getMunicipios, dat_categ, dat_dFechas, dat_salario, dat_contrato, dat_jornada, dat_categoria, dat_ciudad, dat_ciudades }; 